/**
 * friDay Mweb Configurations
 */

const isBeta = /(best-uat)/i.test(location.host);
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

// 建立Cookie
const setCookie = (name, value, days) => {
  const date = new Date();
  // 設定過期時間為指定天數後，這裡是1年（365天）
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + date.toUTCString();
  // 設定 cookie，格式為：name=value; expires=日期; path=/
  document.cookie =
    name +
    '=' +
    value +
    ';' +
    expires +
    ';path=/;';
};

// 取得Cookie
const getCookie = (cname) => {
  var mycookie = document.cookie.split('; ');
  for (var i = 0; i < mycookie.length; i++) {
    var cookie1 = mycookie[i].split('=');
    if (cookie1[0] == cname) {
      return decodeURIComponent(cookie1[1]);
    }
  }
  return null;
};

// 如果URL中有token參數，則將其存入Cookie
const urlParams = new URLSearchParams(location.search);
const token = urlParams.get('token');
if (token) {
  setCookie('FEEC-FA-TOKEN', token, 365);
}

module.exports = {
  setCookie,
  getCookie,
  siteId: () => {
    return isBeta ? 'BW473485' : 'BW831033';
  },
  injectMockData: true, // for dev mode. if true and inject mock
  webCacheExpireTime: 300,
  ecDomain: () => {
    const subdomain = isBeta
      ? isMobile
        ? 'ec2-muat2'
        : 'ec2-uat2'
      : isMobile
      ? 'ec-m'
      : 'ec-w';
    return `https://${subdomain}.shopping.friday.tw/`;
  },
  subDomain: () => {
    let sub = 'best';
    if (isBeta) {
      sub = 'best-uat';
    }
    return sub;
  },
  title: 'friDay嚴選',
  description:
    '【friDay嚴選】是friDay購物專為美安會員成立的專屬購物網站，週週嚴選數十樣商品，提供更優惠的價格及更高的現金回饋，【friDay嚴選】及【friDay購物】永遠是美安會員網路購物的最佳選擇！',
  apiPath: (cusApiRoot) => {
    let schema = 'https://';
    let subdomain = '';
    let domain = '.shopping.friday.tw';
    let apiRoot = '/mobileapi/';
    if (isBeta) {
      subdomain = 'best-uat';
    } else {
      subdomain = 'best';
    }

    if (cusApiRoot) {
      apiRoot = cusApiRoot;
    }

    return schema + subdomain + domain + apiRoot;
  },
  // EC地端API
  frontApiPath: (cusApiRoot) => {
    let schema = 'https://';
    let subdomain = 'front';
    let domain = '.shopping.friday.tw';
    let apiRoot = '/frontendapi/';
    if (isBeta) subdomain = 'front-uat2';
    if (cusApiRoot) apiRoot = cusApiRoot;
    return schema + subdomain + domain + apiRoot;
  },
  // 購物車API
  cartApiPath: (cusApiRoot) => {
    let schema = 'https://';
    let subdomain = 'cart';
    let domain = '.shopping.friday.tw';
    let apiRoot = '/';
    if (isBeta) subdomain = 'cart-dev';
    if (cusApiRoot) apiRoot = cusApiRoot;
    return schema + subdomain + domain + apiRoot;
  },
  // EC雲端API
  frontCloudApiPath: (cusApiRoot) => {
    let schema = 'https://';
    let subdomain = 'frontend-gateway';
    let domain = '.shopping.friday.tw';
    let apiRoot = '/frontendapi/';
    if (isBeta) subdomain = 'frontend-gateway-dev';
    if (cusApiRoot) apiRoot = cusApiRoot;
    return schema + subdomain + domain + apiRoot;
  },
  // AI雲端API
  aiCloudApiPath: (cusApiRoot) => {
    let schema = 'https://';
    let subdomain = 'k8aiapi';
    let domain = '.shopping.friday.tw';
    let apiRoot = '/api/';
    if (isBeta) subdomain = 'aiapi-sit';
    if (cusApiRoot) apiRoot = cusApiRoot;
    return schema + subdomain + domain + apiRoot;
  },
  loginUrl: () => {
    const subDomain = isBeta
      ? isMobile
        ? 'ec2-muat2.'
        : 'ec2-uat2.'
      : isMobile
      ? 'ec-m.'
      : 'ec-w.';
    return (
      'https://' +
      subDomain +
      'shopping.friday.tw/login?requestURL=' +
      encodeURIComponent(location.href)
    );
  },
  sid: () => {
    let sid = 879;
    if (/(best-uat|best-sit|localhost|10\.100)/i.test(location.host)) {
      sid = 879;
    }
    if (/best-sit/i.test(location.host)) {
      sid = 879;
    }
    return sid;
  },
};
